import React, { useState, useEffect } from "react";
import InfoButton from "../info-button/InfoButton";
import "./custom-radio-button.styles.scss";

const CustomRadioButton = (props) => {
    const [isChecked, setIsChecked] = useState(props.checked);

    useEffect(() => {
        setIsChecked(props.value === props.checkedValue);
    }, [props.value, props.checkedValue]);

    const handleClick = (e) => {
        const hasClickedInfoBtnOrItsChildren = e.target.classList.contains("info-button__container") || e.target.classList.contains("info-button__icon");
        if (!isChecked && !hasClickedInfoBtnOrItsChildren) {
            setIsChecked(!isChecked);
            props.onChange(props.value);
        }
    };

    const handleKeyDown = (e) => {
        if (e.code === 'Enter' || e.code === 'Space' || e.code === 'NumpadEnter') {
            setIsChecked(!isChecked);
            props.onChange(props.value);
        }
    };
    
    return (
        <div className={`custom-radio-button ${isChecked ? "checked" : ""}`} tabIndex={0} onClick={handleClick} onKeyDown={handleKeyDown}>
            <InfoButton infoText={props.infoText} onClick={(e) => e.stopPropagation()}/>
            <input
                type="radio"
                id={props.value}
                name={props.name}
                value={props.value}
                checked={isChecked}
                onChange={() => {}}
            />
            <label htmlFor={props.value}>
                {props.label}
            </label>
        </div>
    );
};

export default CustomRadioButton;
